const selectors = {
  sizeButton: '[data-size-button]',
  mediaHolder: '[data-media-slide]',
};

const classes = {
  classExpanded: 'is-expanded',
};

class ImageCaption {
  constructor(container) {
    this.container = container;
    this.sizeButtons = this.container.querySelectorAll(selectors.sizeButton);

    if (this.sizeButtons.length > 0) {
      this.init();
    }
  }

  init() {
    this.sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.toggle(classes.classExpanded);
        button.closest(selectors.mediaHolder).classList.toggle(classes.classExpanded);
      });
    });
  }
}

export {ImageCaption};
